import {truckSvg as Icon__small__truckSvg} from '../Icon__small/Icon__small--truck.js'

export var truck = {
  name: 'truck',
  category: 'icon',
  colorable: true,
  svg: Icon__small__truckSvg,
};
